// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__5WYRg","slideInUp":"Avatar_slideInUp__Un7Fh"};